var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_1116)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H0V100H100V0ZM7.36 8.6125C7.36 7.92116 7.93878 7.36 8.65225 7.36H23.5528C24.2665 7.36 24.845 7.92116 24.845 8.6125V23.5927C24.845 24.2843 24.2665 24.845 23.5528 24.845H8.65225C7.93885 24.845 7.36 24.2843 7.36 23.5929V8.6125ZM12.6734 21.9927V14.1209H10.0569V21.9927H12.6734ZM11.3657 13.0463C12.2779 13.0463 12.8458 12.4418 12.8458 11.6864C12.8288 10.9138 12.2779 10.3262 11.383 10.3262C10.4876 10.3262 9.9027 10.9138 9.9027 11.6864C9.9027 12.4418 10.4704 13.0462 11.3486 13.0462L11.3657 13.0463ZM14.1216 21.9927H16.7379V17.5972C16.7379 17.3622 16.755 17.1267 16.8241 16.9589C17.0132 16.4886 17.4437 16.0018 18.1666 16.0018C19.1131 16.0018 19.492 16.7236 19.492 17.782V21.9927H22.1082V17.4792C22.1082 15.0615 20.8176 13.9363 19.0962 13.9363C17.7084 13.9363 17.0859 14.6991 16.7381 15.2354V14.1212H14.1218C14.1559 14.8596 14.1216 21.9927 14.1216 21.9927Z",
    fill: "#006699"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_1116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.af9b05008cc305fef112701a29cd5aae.svg";
export { ForwardRef as ReactComponent };